import { hFetch } from './hFetch';

export const createAiContent = async ({ task }: { task: string }) => {
  return await hFetch({
    url: `/api/ai_content_generations`,
    method: 'POST',
    payload: {
      ai_content_generation: { task },
    },
  });
};
